import React, { useState, useEffect, useContext, useRef } from "react"
import ImageFromDrupal from "gatsby-theme-blank/src/components/Image/image-from-drupal"
import {
  backgroundContainer,
  backgroundContainerBis,
  backgroundContainerDetails,
  backgroundWrapper,
  backgroundInputWrapper,
  background,
  backgroundText,
  headerAccesDirect,
  notificationButton,
  searchButton,
  searchButtonListing,
  searchWrapper,
  searchOpened,
  headerDescription,
  headerCarousel,
  headerCarouselArrowLeft,
  headerCarouselArrowRight,
  headerDescriptionCarousel,
  headerDescriptionItem,
} from "./header-top.module.scss"
import SearchResults from "gatsby-theme-blank/src/components/search-results"
import ContenuLibre from "gatsby-theme-blank/src/components/ContenuLibre/contenu-libre"
import BandeauAlert from "../../../components/BandeauAlert/bandeau-alert"
import Icon from "gatsby-theme-blank/src/components/Icon/icon"
import root from "window-or-global"
import PropTypes from "prop-types"
import {
  DirectAccess,
  CustomHeaderArrows,
  Container,
  SearchButton,
  NotificationButton,
} from "./header-top-styled"
import { NotificationContext } from "gatsby-theme-blank/src/components/notification-context"
import { AccesDirectContext } from "gatsby-theme-amaryllis/src/components/acces-direct-context"
import { useContenuLibre } from "gatsby-theme-blank/src/components/ContenuLibre/contenu-libre-query"
import { useAccesDirect } from "gatsby-theme-blank/src/components/Home/AccesDirect/acces-direct-query"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import MultiCarousel from "react-multi-carousel"
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox"

const HeaderTop = ({
  isIndex,
  isDetail,
  message,
  children,
  isGdd,
  inputHidden,
}) => {
  const themeColors = useBuildData().theme_settings.palette
  const options = {
    buttons: {
      backgroundColor: themeColors.b_color_gradients.b_dark,
      showAutoplayButton: false,
      showCloseButton: true,
      showDownloadButton: false,
      showFullscreenButton: true,
      showNextButton: false,
      showPrevButton: false,
      showThumbnailsButton: false,
    },
  }
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 900 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 900, min: 0 },
      items: 1,
    },
  }
  const buildInfos = useBuildData().site_settings
  const [results, setResults] = useState([])
  const [searchQuery, setSearchQuery] = useState("")
  const { setIsOpen } = useContext(NotificationContext)
  const [isSearchOpened, setIsSearchOpened] = useState(false)
  const displayDirectAccess =
    useAccesDirect().allDirectLinkEntityDirectLinkEntity.edges.length > 0
  const { isAccesDirectOpen, setIsAccesDirectOpen } = useContext(
    AccesDirectContext
  )
  const [localNavigator, setLocalNavigator] = useState(null)
  const headerBannerNumber = [
    buildInfos.header_banner?.fid,
    buildInfos.header_banner_1?.fid,
    buildInfos.header_banner_2?.fid,
  ].filter((element) => element).length
  let headerDescriptionNumber = useContenuLibre().allNodeContenuLibre.edges.filter(
    (element) =>
      element.node.relationships?.field_taxonomie_zone_libre?.name ===
      "zone_bandeau_accueil"
  )
  headerDescriptionNumber = headerDescriptionNumber.filter(
    (element) => element !== undefined
  )
  const carouselText = useRef()
  const carouselImage = useRef()
  useEffect(() => {
    if (searchQuery && root.__LUNR__) {
      root.__LUNR__.__loaded.then((lunr) => {
        const refs = lunr.fr.index.search(
          `${searchQuery}^100 ${searchQuery}*^10 ${searchQuery}~2`
        )
        const posts = refs.map(({ ref }) => lunr.fr.store[ref])
        setResults(posts)
      })
    }
  }, [searchQuery])

  useEffect(() => {
    setLocalNavigator(navigator)
  }, [])
  let containerClass
  if (isIndex) {
    containerClass = backgroundContainer
  } else if (isDetail) {
    containerClass = backgroundContainerDetails
  } else {
    containerClass = backgroundContainerBis
  }
  return (
    <>
      {!isGdd && (
        <Container className={containerClass}>
          <>
            <div className={backgroundWrapper}>
              {isIndex && (
                <>
                  <MultiCarousel
                    ref={carouselImage}
                    className={headerCarousel}
                    showDots={false}
                    responsive={responsive}
                    infinite={true}
                    arrows={
                      headerBannerNumber > 1 ||
                      headerDescriptionNumber.length > 1
                    }
                    autoPlay={headerBannerNumber > 1}
                    shouldResetAutoplay={headerBannerNumber > 1}
                    autoPlaySpeed={6000}
                    renderButtonGroupOutside={true}
                    customRightArrow={
                      <CustomRightArrow
                        isPlaying={headerBannerNumber > 1}
                        carouselImage={carouselImage}
                        carouselText={carouselText}
                      />
                    }
                    customLeftArrow={
                      <CustomLeftArrow
                        isPlaying={headerBannerNumber > 1}
                        carouselImage={carouselImage}
                        carouselText={carouselText}
                      />
                    }
                    beforeChange={(nextSlide, { currentSlide, onMove }) => {
                      if (headerDescriptionNumber.length > 1) {
                        if (nextSlide - currentSlide > 0) {
                          carouselText.current.next()
                        } else {
                          carouselText.current.previous()
                        }
                      }
                    }}
                  >
                    {buildInfos.header_banner?.fid && (
                      <SimpleReactLightbox>
                        <SRLWrapper options={options}>
                          <ImageFromDrupal
                            className={background}
                            alt={"Banniere " + buildInfos.website_name}
                            drupal_fid={buildInfos.header_banner.fid}
                            ariaHidden={true}
                          />
                        </SRLWrapper>
                      </SimpleReactLightbox>
                    )}
                    {buildInfos.header_banner_1?.fid && (
                      <SimpleReactLightbox>
                        <SRLWrapper options={options}>
                          <ImageFromDrupal
                            className={background}
                            alt={"Banniere " + buildInfos.website_name}
                            drupal_fid={buildInfos.header_banner_1.fid}
                            ariaHidden={true}
                          />
                        </SRLWrapper>
                      </SimpleReactLightbox>
                    )}
                    {buildInfos.header_banner_2?.fid && (
                      <SimpleReactLightbox>
                        <SRLWrapper options={options}>
                          <ImageFromDrupal
                            className={background}
                            alt={"Banniere " + buildInfos.website_name}
                            drupal_fid={buildInfos.header_banner_2.fid}
                            ariaHidden={true}
                          />
                        </SRLWrapper>
                      </SimpleReactLightbox>
                    )}
                  </MultiCarousel>
                  {headerDescriptionNumber.length > 0 && (
                    <div className={headerDescription}>
                      <MultiCarousel
                        ref={carouselText}
                        className={headerDescriptionCarousel}
                        showDots={false}
                        responsive={responsive}
                        swipeable={headerDescriptionNumber.length > 1}
                        draggable={headerDescriptionNumber.length > 1}
                        autoPlay={
                          headerBannerNumber <= 1 &&
                          headerDescriptionNumber.length > 1
                        }
                        shouldResetAutoplay={
                          headerBannerNumber <= 1 &&
                          headerDescriptionNumber.length > 1
                        }
                        autoPlaySpeed={6000}
                        infinite={true}
                        arrows={false}
                        renderButtonGroupOutside={true}
                      >
                        {headerDescriptionNumber
                          .reverse()
                          .map((value, index) => {
                            return (
                              <div
                                className={headerDescriptionItem}
                                key={index}
                              >
                                <ContenuLibre
                                  isIndex={true}
                                  zoneTaxoLibre={
                                    value?.node.relationships
                                      .field_taxonomie_zone_libre.name
                                  }
                                  index={index}
                                  bannerItem={value}
                                />
                              </div>
                            )
                          })}
                      </MultiCarousel>
                    </div>
                  )}
                </>
              )}
              {message && (
                <div className={backgroundText}>
                  <p>{message}</p>
                </div>
              )}
              <div className={backgroundInputWrapper}>
                {inputHidden ? null : (
                  <>
                    {buildInfos.webpush_enabled &&
                    localNavigator?.serviceWorker ? (
                      <NotificationButton
                        aria-label="Bouton de notifications"
                        className={notificationButton}
                        onClick={() => setIsOpen(true)}
                      >
                        <Icon icon="bell" size={16}></Icon>
                      </NotificationButton>
                    ) : null}
                  </>
                )}
                <BandeauAlert alertContent={buildInfos.alert_message.value} />
              </div>
              {inputHidden ? null : (
                <div
                  className={
                    searchWrapper + " " + (isSearchOpened ? searchOpened : "")
                  }
                >
                  <SearchButton
                    aria-label="Bouton de recherche"
                    className={isIndex ? searchButton : searchButtonListing}
                    onClick={() => setIsSearchOpened(!isSearchOpened)}
                  >
                    <Icon icon="search" size={24}></Icon>
                  </SearchButton>
                  <input
                    type="search"
                    id="search-input"
                    name="keywords"
                    onChange={(element) => setSearchQuery(element.target.value)}
                    value={searchQuery}
                    placeholder="Rechercher..."
                    aria-label="Champ de recherche"
                    role="search"
                  />
                </div>
              )}
              {isIndex && displayDirectAccess && (
                <div className={headerAccesDirect}>
                  <DirectAccess
                    href={"#acces-direct"}
                    onClick={() => {
                      setIsAccesDirectOpen(!isAccesDirectOpen)
                    }}
                  >
                    Accès direct
                    <svg width="18px" height="18px" viewBox="0 0 24 24">
                      <g stroke="none" fill="none">
                        <polygon points="0 0 24 0 24 24 0 24" />
                        <path
                          d="M8.2928955,3.20710089 C7.90237121,2.8165766 7.90237121,2.18341162 8.2928955,1.79288733 C8.6834198,1.40236304 9.31658478,1.40236304 9.70710907,1.79288733 L15.7071091,7.79288733 C16.085688,8.17146626 16.0989336,8.7810527 15.7371564,9.17571874 L10.2371564,15.1757187 C9.86396402,15.5828377 9.23139665,15.6103407 8.82427766,15.2371482 C8.41715867,14.8639558 8.38965574,14.2313885 8.76284815,13.8242695 L13.6158645,8.53006986 L8.2928955,3.20710089 Z"
                          fill="#000000"
                          transform="translate(12.000003, 8.499997) scale(-1, -1) rotate(-90.000000) translate(-12.000003, -8.499997) "
                        />
                        <path
                          d="M6.70710678,19.2071045 C6.31658249,19.5976288 5.68341751,19.5976288 5.29289322,19.2071045 C4.90236893,18.8165802 4.90236893,18.1834152 5.29289322,17.7928909 L11.2928932,11.7928909 C11.6714722,11.414312 12.2810586,11.4010664 12.6757246,11.7628436 L18.6757246,17.2628436 C19.0828436,17.636036 19.1103465,18.2686034 18.7371541,18.6757223 C18.3639617,19.0828413 17.7313944,19.1103443 17.3242754,18.7371519 L12.0300757,13.8841355 L6.70710678,19.2071045 Z"
                          fill="#000000"
                          transform="translate(12.000003, 15.499997) scale(-1, -1) rotate(-360.000000) translate(-12.000003, -15.499997) "
                        />
                      </g>
                    </svg>
                  </DirectAccess>
                </div>
              )}
            </div>
          </>
        </Container>
      )}
      {searchQuery !== "" && (
        <SearchResults query={searchQuery} resultats={results} />
      )}
      {searchQuery === "" && (
        <div>
          <main role="main">{children}</main>
        </div>
      )}
    </>
  )
}
const CustomRightArrow = ({ isPlaying, carouselImage, carouselText }) => {
  return (
    <CustomHeaderArrows
      className={headerCarouselArrowRight}
      onClick={() =>
        isPlaying ? carouselImage.current.next() : carouselText.current.next()
      }
    />
  )
}
const CustomLeftArrow = ({ isPlaying, carouselImage, carouselText }) => {
  return (
    <CustomHeaderArrows
      className={headerCarouselArrowLeft}
      onClick={() =>
        isPlaying
          ? carouselImage.current.previous()
          : carouselText.current.previous()
      }
    />
  )
}
//-----------------------Prop-Types---------------------------//

HeaderTop.propTypes = {
  children: PropTypes.node.isRequired,
  isIndex: PropTypes.bool,
  isDetail: PropTypes.bool,
  message: PropTypes.string,
  isGdd: PropTypes.bool,
  inputHidden: PropTypes.bool,
}

CustomLeftArrow.propTypes = {
  onClick: PropTypes.func,
  isPlaying: PropTypes.bool,
  carouselImage: PropTypes.object,
  carouselText: PropTypes.object,
}

CustomRightArrow.propTypes = {
  onClick: PropTypes.func,
  isPlaying: PropTypes.bool,
  carouselImage: PropTypes.object,
  carouselText: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default HeaderTop
